(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grid-density-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__gridDensityControlsInitialized) return;
    window.__gridDensityControlsInitialized = true;

    const getResultsList = (element) => {
      if (!(element instanceof HTMLElement)) return null;

      return (
        element.closest('.shopify-section')?.querySelector('results-list') ||
        document.querySelector('results-list')
      );
    };

    const syncControls = (scope = document) => {
      const resultsList = scope.querySelector?.('results-list') || document.querySelector('results-list');
      if (!(resultsList instanceof HTMLElement)) return;

      const grid = resultsList.querySelector('[product-grid-view]');
      if (!(grid instanceof HTMLElement)) return;

      const currentView = grid.getAttribute('product-grid-view') || 'default';
      const groupName = window.innerWidth >= 750 ? 'grid' : 'grid-mobile';

      document.querySelectorAll(`.column-options-wrapper input[name="${groupName}"]`).forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;
        input.checked = input.value === currentView;
      });
    };

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.closest('.column-options-wrapper')) return;

      const resultsList = getResultsList(target);
      if (resultsList && typeof resultsList.updateLayout === 'function') {
        resultsList.updateLayout({ target });
      }
    });

    window.addEventListener('resize', () => syncControls(), { passive: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncControls(), { once: true });
    } else {
      syncControls();
    }

    const observer = new MutationObserver(() => syncControls());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__priceFacetRangeInitialized) return;
    window.__priceFacetRangeInitialized = true;

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const parseMoneyInput = (value, fallback) => {
      if (!value?.trim()) return fallback;

      let normalized = value.replace(/[^\d,.-]/g, '');
      if (!normalized) return fallback;

      const hasComma = normalized.includes(',');
      const hasDot = normalized.includes('.');

      if (hasComma && hasDot) {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
      } else if (hasComma) {
        normalized = normalized.replace(',', '.');
      }

      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? Math.round(parsed * 100) : fallback;
    };

    const formatMoneyInput = (minorUnits) => {
      const majorUnits = minorUnits / 100;
      return majorUnits.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    };

    const getParts = (component) => {
      if (!(component instanceof HTMLElement)) return null;

      const minInput = component.querySelector('[ref="minInput"]');
      const maxInput = component.querySelector('[ref="maxInput"]');
      const minRange = component.querySelector('[data-range-input="min"]');
      const maxRange = component.querySelector('[data-range-input="max"]');
      const progress = component.querySelector('[data-range-progress]');

      if (
        !(minInput instanceof HTMLInputElement) ||
        !(maxInput instanceof HTMLInputElement) ||
        !(minRange instanceof HTMLInputElement) ||
        !(maxRange instanceof HTMLInputElement) ||
        !(progress instanceof HTMLElement)
      ) {
        return null;
      }

      const minAllowed = Number(minRange.min) || 0;
      const maxAllowed = Number(maxRange.max) || 0;
      const step = Number(minRange.step) || 100;

      return { minInput, maxInput, minRange, maxRange, progress, minAllowed, maxAllowed, step };
    };

    const updateProgress = ({ progress, minAllowed, maxAllowed }, minValue, maxValue) => {
      const start = ((minValue - minAllowed) / (maxAllowed - minAllowed)) * 100;
      const end = ((maxValue - minAllowed) / (maxAllowed - minAllowed)) * 100;
      progress.style.left = `${start}%`;
      progress.style.width = `${Math.max(end - start, 0)}%`;
    };

    const syncRangesFromInputs = (component) => {
      const parts = getParts(component);
      if (!parts || parts.maxAllowed <= parts.minAllowed) return;

      let minValue = clamp(
        parseMoneyInput(parts.minInput.value, parts.minAllowed),
        parts.minAllowed,
        parts.maxAllowed
      );
      let maxValue = clamp(
        parseMoneyInput(parts.maxInput.value, parts.maxAllowed),
        parts.minAllowed,
        parts.maxAllowed
      );

      if (minValue > maxValue) {
        if (document.activeElement === parts.minInput) {
          maxValue = minValue;
        } else {
          minValue = maxValue;
        }
      }

      parts.minRange.value = String(minValue);
      parts.maxRange.value = String(maxValue);
      updateProgress(parts, minValue, maxValue);
    };

    const syncInputsFromRanges = (component, changedRange, shouldCommit = false) => {
      const parts = getParts(component);
      if (!parts || parts.maxAllowed <= parts.minAllowed) return;

      let minValue = clamp(Number(parts.minRange.value), parts.minAllowed, parts.maxAllowed);
      let maxValue = clamp(Number(parts.maxRange.value), parts.minAllowed, parts.maxAllowed);

      if (maxValue - minValue < parts.step) {
        if (changedRange === 'min') {
          minValue = clamp(maxValue - parts.step, parts.minAllowed, parts.maxAllowed);
        } else {
          maxValue = clamp(minValue + parts.step, parts.minAllowed, parts.maxAllowed);
        }

        parts.minRange.value = String(minValue);
        parts.maxRange.value = String(maxValue);
      }

      parts.minInput.value = minValue > parts.minAllowed ? formatMoneyInput(minValue) : '';
      parts.maxInput.value = maxValue < parts.maxAllowed ? formatMoneyInput(maxValue) : '';
      updateProgress(parts, minValue, maxValue);

      if (shouldCommit) {
        const targetInput = changedRange === 'max' ? parts.maxInput : parts.minInput;
        targetInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll?.('price-facet-component').forEach((component) => {
        syncRangesFromInputs(component);
      });
    };

    document.addEventListener('input', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      if (target.matches('[data-range-input="min"], [data-range-input="max"]')) {
        const component = target.closest('price-facet-component');
        if (!component) return;
        syncInputsFromRanges(component, target.getAttribute('data-range-input') === 'max' ? 'max' : 'min');
        return;
      }

      if (target.matches('[ref="minInput"], [ref="maxInput"]')) {
        const component = target.closest('price-facet-component');
        if (!component) return;
        syncRangesFromInputs(component);
      }
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      if (target.matches('[data-range-input="min"], [data-range-input="max"]')) {
        const component = target.closest('price-facet-component');
        if (!component) return;
        syncInputsFromRanges(
          component,
          target.getAttribute('data-range-input') === 'max' ? 'max' : 'min',
          true
        );
        return;
      }

      if (target.matches('[ref="minInput"], [ref="maxInput"]')) {
        const component = target.closest('price-facet-component');
        if (!component) return;
        syncRangesFromInputs(component);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    const observer = new MutationObserver((records) => {
      for (const record of records) {
        record.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('price-facet-component')) {
            syncRangesFromInputs(node);
            return;
          }

          initializeAll(node);
        });
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
